{
  "help": {
    "meta": {
      "title": "Ayuda - MAJORITY",
      "description": "¿Tienes preguntas sobre MAJORITY? ¡Nuestro equipo de servicio al cliente está aquí para ayudarte cuando lo necesites!"
    },
    "breadcrumb_labels": {
      "home": "Centro de ayuda",
      "search_results": "Resultados de la búsqueda"
    },
    "related_articles": "Artículos relacionados",
    "article_not_found": "Artículo no encontrado",
    "article_not_found_message":"No hemos podido encontrar este artículo. Quizás buscabas alguno de estos:",
    "article_not_found_search_message": "No hemos podido encontrar este artículo. Prueba usar el buscador de arriba para encontrar lo que buscas.",
    "categories": "Categorías",
    "explore_tutorials": "Explora nuestros tutoriales y comprueba lo fácil que es hacer las cosas con MAJORITY",
    "help_contact": {
      "title": "Contáctanos",
      "call_us": "Llámanos",
      "ask_us": "Pregúntanos",
      "meetup_place": "MAJORITY Meetup"
    },
    "meetup": {
      "address": "9801 V Bissonnet Street<br/>Houston, Texas"
    },
    "labels": {
      "search_placeholder": "Escribe tu término de búsqueda…",
      "see_all": "Ver todo",
      "watch_and_learn": "Mira y aprende"
    },
    "help_article": {
      "related_articles": "Artículos relacionados",
      "table_of_content": "Índice"
    },
    "help_contact_form": {
      "title": "Estamos aquí para ayudar",
      "description": "Responde todo el formulario para que podamos ayudarte lo más rápido posible. ¡Por lo general respondemos dentro de las siguientes 5 horas!",
      "description_2": "Si prefieres escribir tu propio correo electrónico, puedes enviarlo a <a class=\"{variant}\" href=\"mailto:{email}\">{email}</a>.",
      "full_name_field": "Nombre completo",
      "email_address_field": "Correo electrónico",
      "phone_number_field": "Número de teléfono",
      "decription_field": "Describe en qué necesitas ayuda",
      "send_question": "Enviar pregunta",
      "success_title": "Gracias por compartir tu problema",
      "success_message": "Haremos lo posible para ayudarte en las siguientes 24 horas, pero toma en cuenta que podemos tardar más durante horas pico, días festivos y fines de semana.<br>¡Queremos que tu experiencia con MAJORITY sea aún mejor!<br><br>- El Equipo de MAJORITY",
      "error_title": "Uy, solicitud no recibida",
      "error_message": "Parece que hay un problema de conexión. Mejor intenta enviar un correo electrónico a <a class=\"{variant}\" href=\"mailto:{email}\">{email}</a>.<br>¡Queremos que tu experiencia con MAJORITY sea aún mejor!<br><br>- El Equipo de MAJORITY",
      "done": "OK"
    }
  }
  
}